import { render, staticRenderFns } from "./MyBookingList.vue?vue&type=template&id=508fb4f1&"
import script from "./MyBookingList.vue?vue&type=script&lang=js&"
export * from "./MyBookingList.vue?vue&type=script&lang=js&"
import style0 from "./MyBookingList.vue?vue&type=style&index=0&id=508fb4f1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('508fb4f1')) {
      api.createRecord('508fb4f1', component.options)
    } else {
      api.reload('508fb4f1', component.options)
    }
    module.hot.accept("./MyBookingList.vue?vue&type=template&id=508fb4f1&", function () {
      api.rerender('508fb4f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyBooking/MyBookingList.vue"
export default component.exports